// What the host stores of a conversation (docs/07 "What is metadata and what is content"):
// per event its sequence number, type, direction, time and tool name from the plaintext
// metadata, and the ciphertext's size. The "show what the host sees" view draws these.
import type { EventView } from "./model";

export interface HostRow {
  key: string;
  seq: number;
  type: string;
  direction: EventView["direction"];
  at: number | undefined;
  tool: string | undefined;
  /** Ciphertext plus tag, in bytes. */
  bytes: number;
}

function metaField(meta: unknown, key: string): unknown {
  return meta && typeof meta === "object" && key in meta ? (meta as Record<string, unknown>)[key] : undefined;
}

export function hostRow(event: EventView): HostRow {
  const wrapper = metaField(event.meta, "wrapper");
  return {
    key: `${event.segmentId}:${event.direction}:${event.seq}`,
    seq: event.seq,
    type: event.type,
    direction: event.direction,
    at: eventTime(event),
    tool: typeof wrapper === "string" ? wrapper : eventTool(event),
    bytes: event.raw.ciphertext.length + event.raw.tag.length,
  };
}

/** The event's time from its metadata, when the worker sent one. */
export function eventTime(event: EventView): number | undefined {
  const at = metaField(event.meta, "at");
  return typeof at === "number" ? at : undefined;
}

export function eventTool(event: EventView): string | undefined {
  const tool = metaField(event.meta, "tool");
  return typeof tool === "string" ? tool : undefined;
}
